import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface RedirectProps {
  path: string;
}

export const Redirect: React.FC<RedirectProps> = (props) => {
  const { path } = props;
  const navigate = useNavigate();

  useEffect(() => {
    navigate(path, { replace: true });
  }, []);

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
      }}
    >
      <div style={{ fontSize: 18 }}>Redirecting...</div>
    </div>
  );
};
